import { createComponent } from '@lit/react';
import {} from '@mgCommon/elements/base-date-time-picker.element';
import { ToastElement as ToastElementWC } from '@mgCommon/elements/toast.element';
import React from 'react';

const AppToast = createComponent({
  react: React,
  tagName: 'app-toast',
  elementClass: ToastElementWC,
});

export default AppToast;
